import api from "../api";

export async function getPointsTables(id) {
    return await api.get(`points/tables/${id}`)
}